import { useEffect, useState } from 'react';
import { Modal } from '../components/Modal';
import { Api } from '@infra/api';

export function Dashboard() {
  const [open, setOpen] = useState<null | 'analyses' | 'norms' | 'groups' | 'units' | 'contexts' | 'deviations' | 'textRules' | 'specializations'>(null);
  const [counts, setCounts] = useState<{ analyses: number; norms: number }>({ analyses: 0, norms: 0 });

  useEffect(() => {
    async function load() {
      try {
        const [a, n] = await Promise.all([Api.listAnalyses(), Api.listAllNorms()]);
        setCounts({ analyses: a.length, norms: n.length });
      } catch (e) {
        console.error(e);
      }
    }
    load();
  }, []);

  return (
    <div>
      <div className="toolbar">
        <div className="title">
          <img src="/logo.png" alt="logo" style={{height: 32, width: 'auto', maxWidth: 120}} />
          <h2 style={{margin:0}}>Информация</h2>
        </div>
      </div>
      <div className="cards">
        <div className="card">
          <div className="badge">Статистика</div>
          <h3>В системе</h3>
          <p>Анализов: <b>{counts.analyses}</b></p>
          <p>Параметров (норм): <b>{counts.norms}</b></p>
        </div>
        <div className="card" style={{cursor:'pointer'}} onClick={()=>setOpen('analyses')}>
          <div className="badge">Анализы</div>
          <h3>Создание и редактирование анализов</h3>
          <p>Базовые записи анализов без норм</p>
        </div>
        <div className="card" style={{cursor:'pointer'}} onClick={()=>setOpen('norms')}>
          <div className="badge">Параметры</div>
          <h3>Диапазоны, единицы, контексты</h3>
          <p>Числовые и текстовые нормы, пороги серьёзных отклонений</p>
        </div>
        <div className="card" style={{cursor:'pointer'}} onClick={()=>setOpen('groups')}>
          <div className="badge">Группы</div>
          <h3>Пол и возраст</h3>
          <p>Половые/возрастные группы, беременность как отдельные группы</p>
        </div>
        <div className="card" style={{cursor:'pointer'}} onClick={()=>setOpen('specializations')}>
          <div className="badge">Специализации</div>
          <h3>Справочник медицинских специализаций</h3>
          <p>Список специализаций для привязки правил и норм к врачам/отделениям</p>
        </div>
      </div>

      {open === 'analyses' && (
        <Modal title="Как завести анализ" onClose={()=>setOpen(null)}>
          <ol>
            <li>Откройте раздел «Анализы».</li>
            <li>Заполните поля: Название, Описание, Тип (например, материал/категория), Статус.</li>
            <li>Нажмите «Создать». Анализ появится в списке. По клику на строку откроется модальное окно с полным описанием и связанными нормами.</li>
          </ol>
          <p style={{color:'var(--muted)'}}>Совет: уникальность обеспечивается полем названия, именно по нему подтягиваются связанные нормы.</p>
        </Modal>
      )}

      {open === 'norms' && (
        <Modal title="Как завести норму (параметр)" onClose={()=>setOpen(null)}>
          <ol>
            <li>Откройте раздел «Нормы» и нажмите «Новый параметр».</li>
            <li>Выберите Анализ, при необходимости — Группу (пол/возраст), Единицу и Контекст.</li>
            <li>Заполните метаданные: Название нормы, Код, Описание, Тип значения (numeric | text).</li>
            <li>Для numeric задайте диапазон нормы (мин/макс) и пороги серьёзного отклонения (≤, ≥).</li>
            <li>Сохраните. Внизу в таблице «Все нормы» появится запись, клик по строке откроет модальное окно для правки.</li>
          </ol>
          <p style={{color:'var(--muted)'}}>Примечание: для текстовых значений используйте раздел «Синонимы».</p>
        </Modal>
      )}

      {open === 'groups' && (
        <Modal title="Как завести группу (пол/возраст)" onClose={()=>setOpen(null)}>
          <ol>
            <li>Откройте раздел «Группы».</li>
            <li>Заполните: Название, Пол, Возрастной диапазон (мин/макс, включительно).</li>
            <li>Сохраните. Группа используется при назначении норм, чтобы учитывать пол и возраст.</li>
          </ol>
          <p style={{color:'var(--muted)'}}>Совет: беременность можно оформить как отдельные группы (например, «Беременные 1–2 триместр»).</p>
        </Modal>
      )}
      
      {open === 'specializations' && (
        <Modal title="Как завести специализацию" onClose={()=>setOpen(null)}>
          <ol>
            <li>Откройте раздел «Специализации».</li>
            <li>Укажите название специализации (например, «Эндокринолог», «Кардиолог»).</li>
            <li>Сохраните. Специализации используются для привязки норм и правил интерпретации к профилю врача/отделения.</li>
          </ol>
          <p style={{color:'var(--muted)'}}>Совет: можно добавлять как узкие, так и широкие специализации, в зависимости от ваших процессов.</p>
        </Modal>
      )}
    </div>
  );
}


